import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import Pagination from "../Component/Pagination";
import {
  bookinlist,
  cancelreason,
  refundAmount,
} from "../Redux/Action/BookingAction";
import { useDispatch, useSelector } from "react-redux";
import Flag from "react-flagkit";
import Contry from "../Component/Contry";
import { careseekerlistinfo } from "../Redux/Action/CareSeekerAction";
import { Button, Modal } from "react-bootstrap";
import FirstLetterCapital from "../CustomHooks/FirstLetterCapital";
import { Tooltip as ReactTooltip } from "react-tooltip";
export default function BookingCancelRequest() {
  const [show, setshow] = useState(false);
  const [id, setid] = useState("");
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  
  useEffect(() => {
    setLoading(true);
    dispatch(
      bookinlist({
        search: "",
        status: "cancellation_pending",
        page: 1,
        limit: 15,
      })
    ).finally(() => setLoading(false));
    dispatch(cancelreason());
  }, [dispatch]);
  const list = useSelector((state) => state.Booking.booking);
  useEffect(() => {
    dispatch(
      careseekerlistinfo({
        role: ["carer"],
        limit: 10000,
        page: 1,
      })
    );
  }, [dispatch]);

  const resasonlist = useSelector((state) => state.Booking.resasonlist);

  //resasonlist
  const handleClose = () => {
    setshow(false);
    setid("");
  };

  //updatebookingcarer

  const handelsearch = () => {
    setLoading(true);
    if (search !== "") {
      dispatch(
        bookinlist({
          search: search,
          status: "cancellation_pending",
          page: page,
          limit: 10,
        })
      ).finally(() => setLoading(false));
    } else {
      dispatch(
        bookinlist({
          search: "",
          status: "cancellation_pending",
          page: page,
          limit: 10,
        })
      ).finally(() => setLoading(false));
    }
  };

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
    setLoading(true);
    dispatch(
      bookinlist({
        search: "",
        status: "cancellation_pending",
        page: e.selected + 1,
        limit: 10,
      })
    ).finally(() => setLoading(false));
  };

  const refundpayment = () => {
    dispatch(
      refundAmount({
        booking_id: id,
      })
    ).then(function () {
      setshow(false);
      setid("");
      setLoading(true);
      dispatch(
        bookinlist({
          search: "",
          status: "cancellation_pending",
          page: 1,
          limit: 15,
        })
      ).finally(() => setLoading(false));
    });
  };

  //refund

  return (
    <Layout>
      {/* Header */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Booking Cancellation Requests</h1>
              <p className="text-gray-600 mt-1">Manage pending cancellation requests and process refunds</p>
            </div>
            <div className="flex items-center space-x-3">
              <div className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium">
                {list?.data?.length || 0} Pending
              </div>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="p-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search by booking ID..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
                />
                {search && (
                  <button
                    onClick={() => setSearch('')}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
            <button
              onClick={handelsearch}
              className="px-6 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors"
            >
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gradient-to-r from-red-50 to-red-100 border-b border-red-200">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Booking Number</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Customer</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Contact</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Amount</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Cancellation Reason</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan={6} className="px-6 py-12 text-center text-gray-500">
                    <div className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-red-500 mr-2"></div>
                      Loading cancellation requests...
                    </div>
                  </td>
                </tr>
              ) : !list?.data?.length ? (
                <tr>
                  <td colSpan={6} className="px-6 py-12 text-center text-gray-500">
                    <div className="flex flex-col items-center">
                      <svg className="w-12 h-12 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <p className="text-lg font-medium text-gray-900 mb-1">No cancellation requests</p>
                      <p className="text-gray-500">There are no pending cancellation requests at the moment.</p>
                    </div>
                  </td>
                </tr>
              ) : (
                list.data.map((object, i) => (
                  <tr key={i} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-medium text-gray-900">#{object?.booking_number}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <img
                          src={
                            object?.care_seeker?.profile_picture ||
                            "https://i.imghippo.com/files/tE3170G.webp"
                          }
                          alt="profile"
                          className="w-10 h-10 rounded-full object-cover mr-3"
                        />
                        <div>
                          <div className="font-medium text-gray-900">
                            {FirstLetterCapital(
                              `${object?.care_seeker?.first_name || ""} ${object?.care_seeker?.last_name || ""}`.trim()
                            )}
                          </div>
                          <div className="text-sm text-gray-500">{object?.care_seeker?.email}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center text-sm text-gray-900">
                        {object?.care_seeker?.phone?.country_code && (
                          <Flag
                            country={Contry(object?.care_seeker?.phone?.country_code)}
                            size={16}
                            className="mr-2"
                          />
                        )}
                        <span>
                          {object?.care_seeker?.phone?.country_code} {object?.care_seeker?.phone?.number}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="font-semibold text-green-600">
                        {object?.payment_details?.total_amount?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="max-w-xs">
                        <div 
                          className="text-sm text-gray-900 truncate cursor-help"
                          data-tooltip-id={`reason-${i}`}
                          data-tooltip-content={object?.traillist?.cancelled_by?.reason || "No reason provided"}
                        >
                          {object?.traillist?.cancelled_by?.reason || "No reason provided"}
                        </div>
                        <ReactTooltip id={`reason-${i}`} place="top" />
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => {
                          setshow(true);
                          setid(object?._id);
                        }}
                        className="inline-flex items-center px-3 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
                        data-tooltip-id={`refund-${i}`}
                        data-tooltip-content="Process refund for this cancellation"
                      >
                        <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                        </svg>
                        Process Refund
                      </button>
                      <ReactTooltip id={`refund-${i}`} place="top" />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        {/* Pagination */}
        {list?.data?.length > 0 && (
          <div className="px-6 py-4 border-t border-gray-200">
            <Pagination
              handlePageClick={handlePageClick}
              pageCount={Math.ceil((list?.totalItems || 0) / 10)}
            />
          </div>
        )}
      </div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Refund Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to proceed with the refund for this booking?
            </p>
            <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
              <div className="flex">
                <svg className="w-5 h-5 text-yellow-400 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <div>
                  <h4 className="text-sm font-medium text-yellow-800">Important</h4>
                  <p className="text-sm text-yellow-700 mt-1">
                    This action cannot be undone. The refund will be processed immediately.
                  </p>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                refundpayment();
              }}
            >
              Process Refund
            </Button>
          </Modal.Footer>
        </Modal>
    </Layout>
  );
}
